import { useEffect, useState } from "react";
import api from "../api";
import { Bounce, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CustomSelect from "../CustomSelect";
import "./ricerche.css";

const AddRicerche = () => {
  const [loading, setLoading] = useState(false);
  const [titoloModulo, setTitoloModulo] = useState("");
  const [titoloCorso, setTitoloCorso] = useState("");
  const [errors, setErrors] = useState({});
  const [ore, setOre] = useState("");
  const [sedi, setSedi] = useState([]);
  const [mansioni, setMansioni] = useState([]);
  const [sedeId, setSedeId] = useState("");
  const [mansioneId, setMansioneId] = useState("");
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(false);

  useEffect(() => {
    const userRole = localStorage.getItem("userRole");
    if (userRole !== "OPERATOR") {
      alert("Accedi come operatore per aggiungere le ricerche!");

      localStorage.clear();
      navigate("/login");
    } else {
      setIsAuthorized(true);
      fetchSedi();
      fetchMansioni();
    }
  }, [navigate]);

  const fetchSedi = async () => {
    try {
      setLoading(true);
      const response = await api.get("/sedi/me");
      if (response.status === 200) {
        const sediList = response.data;
        setSedi(sediList);

        if (sediList.length === 1) {
          const onlySedeId = sediList[0].idSede || sediList[0].id;
          setSedeId(onlySedeId);
        }

        if (sediList.length === 0) {
          toast.warn("Non sei assegnato in nessuna sede!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Bounce,
          });
        }
      } else {
        toast.error("Sede non esiste!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchMansioni = async () => {
    try {
      setLoading(true);
      const response = await api.get("/mansioni");
      if (response.status === 200) {
        setMansioni(response.data);
      } else {
        toast.error("Errore durante il caricamento delle mansioni!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  const isValid = () => {
    const errorsInput = {};
    if (!sedeId) errorsInput.sede = "Seleziona una sede!";
    if (!mansioneId) errorsInput.mansione = "Seleziona una mansione!";
    if (!titoloModulo)
      errorsInput.titoloModulo = "Titolo Modulo è obbligatorio!";
    if (!titoloCorso) errorsInput.titoloCorso = "Titolo Corso è obbligatorio!";
    if (!ore) {
      errorsInput.ore = "Ore è obbligatorio!";
    } else if (isNaN(ore)) {
      errorsInput.ore = "Ore deve essere un numero!";
    }

    setErrors(errorsInput);
    return Object.keys(errorsInput).length === 0;
  };

  const addRicerche = async () => {
    if (!isValid()) return;

    try {
      setLoading(true);
      const response = await api.post("/ricerche", {
        idSede: parseInt(sedeId),
        idMansione: parseInt(mansioneId),
        titoloModulo,
        titoloCorso,
        ore: parseInt(ore),
        statoRicerca: "APERTA",
      });

      if (response.status === 201) {
        toast.success("Ricerca aggiunta con successo!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        navigate("/ricerche/me");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
      });
    } finally {
      setLoading(false);
    }
  };

  if (!isAuthorized) return null;

  const handleTitoloModuloChange = (value) => {
    setTitoloModulo(value);
    setErrors((prev) => ({ ...prev, titoloModulo: "" }));
  };

  const handleTitoloCorsoChange = (value) => {
    setTitoloCorso(value);
    setErrors((prev) => ({ ...prev, titoloCorso: "" }));
  };

  const handleOreChange = (value) => {
    setOre(value);
    setErrors((prev) => ({ ...prev, ore: "" }));
  };

  const handleSedeChange = (value) => {
    setSedeId(value);
    setErrors((prev) => ({ ...prev, sede: "" }));
  };

  const handleMansioneChange = (value) => {
    setMansioneId(value);
    setErrors((prev) => ({ ...prev, mansione: "" }));
  };

  return (
    <div className="add-ricerche-modern-bg">
      {loading && (
        <div className="add-ricerche-modern-overlay">
          <div className="add-ricerche-modern-spinner"></div>
        </div>
      )}
      <div className="add-ricerche-modern-card">
        <div className="add-ricerche-modern-header">
          <button
            onClick={() => navigate("/ricerche/me")}
            className="add-ricerche-modern-back"
            title="Torna indietro"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2>
            <i className="fa-solid fa-search-plus"></i>
            Aggiungi Ricerca
          </h2>
        </div>
        <form
          className="add-ricerche-modern-form"
          onSubmit={(e) => {
            e.preventDefault();
            addRicerche();
          }}
        >
          <div className="add-ricerche-modern-fields">
            <div className="add-ricerche-modern-field">
              <label className="add-ricerche-modern-label">
                <i className="fa-solid fa-building"></i>
                Sede
              </label>
              <CustomSelect
                options={sedi.map((sede) => ({
                  value: String(sede.idSede || sede.id),
                  label: sede.indirizzoSede || `Sede ${sede.idSede || sede.id}`,
                }))}
                value={
                  sedeId
                    ? {
                        value: String(sedeId),
                        label:
                          sedi.find(
                            (s) => String(s.idSede || s.id) === String(sedeId)
                          )?.indirizzoSede || `Sede ${sedeId}`,
                      }
                    : null
                }
                onChange={(option) => handleSedeChange(option?.value || "")}
                placeholder="Seleziona una sede"
                isDisabled={sedi.length === 1}
              />
              {errors.sede && (
                <span className="add-ricerche-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.sede}
                </span>
              )}
            </div>
            <div className="add-ricerche-modern-field">
              <label className="add-ricerche-modern-label">
                <i className="fa-solid fa-tasks"></i>
                Mansione
              </label>
              <CustomSelect
                options={mansioni.map((mansione) => ({
                  value: String(mansione.idMansione),
                  label:
                    mansione.nomeMansione || `Mansione ${mansione.idMansione}`,
                }))}
                value={
                  mansioneId
                    ? {
                        value: String(mansioneId),
                        label:
                          mansioni.find(
                            (m) => String(m.idMansione) === String(mansioneId)
                          )?.nomeMansione || `Mansione ${mansioneId}`,
                      }
                    : null
                }
                onChange={(option) => handleMansioneChange(option?.value || "")}
                placeholder="Seleziona una mansione"
              />
              {errors.mansione && (
                <span className="add-ricerche-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.mansione}
                </span>
              )}
            </div>
            <div className="add-ricerche-modern-field">
              <label className="add-ricerche-modern-label">
                <i className="fa-solid fa-file-alt"></i>
                Titolo Modulo
              </label>
              <input
                type="text"
                value={titoloModulo}
                onChange={(e) => handleTitoloModuloChange(e.target.value)}
                placeholder="Inserisci il titolo del modulo"
                className={errors.titoloModulo ? "error" : ""}
              />
              {errors.titoloModulo && (
                <span className="add-ricerche-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.titoloModulo}
                </span>
              )}
            </div>
            <div className="add-ricerche-modern-field">
              <label className="add-ricerche-modern-label">
                <i className="fa-solid fa-graduation-cap"></i>
                Titolo Corso
              </label>
              <input
                type="text"
                value={titoloCorso}
                onChange={(e) => handleTitoloCorsoChange(e.target.value)}
                placeholder="Inserisci il titolo del corso"
                className={errors.titoloCorso ? "error" : ""}
              />
              {errors.titoloCorso && (
                <span className="add-ricerche-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.titoloCorso}
                </span>
              )}
            </div>
            <div className="add-ricerche-modern-field">
              <label className="add-ricerche-modern-label">
                <i className="fa-solid fa-clock"></i>
                Ore
              </label>
              <input
                type="number"
                value={ore}
                onChange={(e) => handleOreChange(e.target.value)}
                placeholder="Inserisci le ore"
                className={errors.ore ? "error" : ""}
              />
              {errors.ore && (
                <span className="add-ricerche-modern-error">
                  <i className="fa-solid fa-exclamation-triangle"></i>
                  {errors.ore}
                </span>
              )}
            </div>
          </div>
          <div className="add-ricerche-modern-actions">
            <button
              type="button"
              className="add-ricerche-modern-cancel"
              onClick={() => navigate("/ricerche/me")}
            >
              <i className="fa-solid fa-times"></i>
              Annulla
            </button>
            <button type="submit" className="add-ricerche-modern-save">
              <i className="fa-solid fa-plus"></i>
              Aggiungi
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddRicerche;
